import React from 'react'
import {useState,useEffect} from "react"
import { axiosInstance } from "../axios/Axios";
import { useParams } from "react-router-dom";
import CheckBox from './graphs/CheckBox';
import UniComment from './graphs/UniComment';
import BiComment from './graphs/BiComment';
import RadioGroup from './graphs/RadioGroup';
import Rating from './graphs/Rating';

const Analyse = () => {
    const { gid } = useParams();

    const [qnans,setQnans] = useState(null);

    useEffect(() => {

        axiosInstance.get('survey/analyse/'+gid+'/')
            .then((res) => {
                setQnans(res.data)
            })
    },[])

    if (qnans===null)
    {
        return  <p>loading</p>
    }

    if("msg" in qnans)
    {
        if(qnans["msg"]==="error")
            return <div>Error</div>

        else if(qnans["msg"]==="didn't train")
            return <div>Train the model for viewing it</div>
        
    }

    var display=[]
    for (let qn in qnans) 
    {
        if(qnans[qn]["type"]==="comment")
        {
            if(qnans[qn]["comment_type"]==="bi")
            {
                display.push(<BiComment data={qnans[qn]}/>)
            }
            else{
                display.push(<UniComment data={qnans[qn]}/>)
            }
        }
        else if (qnans[qn]["type"]==="checkbox")
        {
            display.push(<CheckBox data={qnans[qn]}/>)
        }
        else if (qnans[qn]["type"]==="radiogroup")
        {
            display.push(<RadioGroup data={qnans[qn]}/>)
        }
        else if (qnans[qn]["type"]==="rating")
        {
            display.push(<Rating data={qnans[qn]}/>)
        }
      }   
    return (
        <div className="container my-5">
            <div className='display-1 mb-5'>Survey Insights</div>
            <div className="d-flex justify-content-between align-items-center flex-wrap " >
                {display}
            </div>
        </div>
    )
}

export default Analyse
